<template>
  <MediaVideoPlayer
    v-if="actualSrc"
    ref="mediaVideoPlayer"
    :poster="posterUrl"
    :sources="[
      {
        src: videoSrc ?? actualSrc,
        type: 'application/x-mpegURL',
      },
    ]"
    :autoplay="autoplay"
    :loop="loop"
    class="w-full"
    :controls="controls"
    fill
    :muted="muted"
    :video-class="videoClass"
    :image-style="imageStyle"
    :is-landing="isLanding"
    :is-hero="isHero"
  />
</template>

<script lang="ts" setup>
import type { DefineImageStyleConfig } from '#rokka/types'
import type { MediaVideoPlayer } from '#build/components'
import type { MediaVideoFragment } from '#graphql-operations'

type MediaVideoProps = MediaVideoFragment & {
  autoplay?: boolean
  loop?: boolean
  controls?: boolean
  videoClass?: string
  video: MediaVideoFragment['video']
  muted?: boolean
  videoSrc?: string
  imageStyle: DefineImageStyleConfig
  isLanding?: boolean
  poster?: MediaVideoFragment['poster']
  isHero?: boolean
}

const props = defineProps<MediaVideoProps>()

const videoRokkaHash = computed(() => props.video?.file?.rokka?.hash)
const posterUrl = computed<string | undefined>(() => {
  return getRokkaUrl(props.poster?.file?.rokka?.hash ?? videoRokkaHash.value)
})

const actualSrc = computed(() => {
  return getRokkaUrl(
    videoRokkaHash.value ?? props.video?.file?.rokka?.hash,
    'm3u',
  )
})

const mediaVideoPlayer = ref<typeof MediaVideoPlayer>()
const play = () => {
  if (mediaVideoPlayer.value) {
    mediaVideoPlayer.value.play()
  }
}

defineExpose({
  play,
})

defineOptions({
  name: 'MediaVideo',
})
</script>
